import React from 'react';
import { Tooltip, TooltipRefProps } from 'react-tooltip';

export function IODropdown({
  afterHide,
  children,
  id,
  isOpen,
  setIsOpen,
  tooltipRef
}: {
  afterHide: () => void;
  children: React.ReactNode;
  id: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  tooltipRef: React.RefObject<TooltipRefProps | null>;
}) {
  return (
    <Tooltip
      id={id}
      afterHide={afterHide}
      clickable
      imperativeModeOnly
      isOpen={isOpen}
      noArrow
      opacity={1}
      openOnClick
      place="bottom-start"
      ref={tooltipRef}
      setIsOpen={setIsOpen}
      style={{
        backgroundColor: 'transparent',
        boxShadow:
          '0px -8px 18px 0px rgba(13, 10, 44, 0.04), 0px 13px 40px 0px rgba(13, 10, 44, 0.12)',
        borderRadius: '8px',
        padding: '0',
        zIndex: '9999'
      }}>
      {children}
    </Tooltip>
  );
}
